// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"00bcc132","455":"ac717788","977":"0e3a0072"}[chunkId] + ".chunk.js";
};